module.exports = __webpack_public_path__ + "media/images/edgar_sobre-cfdc3851bf3a38d003fca6379db7333f.png";